import { ApiUrl, ApiUrlAdmin } from "../common/Config";
import { postAdmin,post,get,getAdmin,postFormData } from "../common/Helper";

export const generateCodes = async (data,token,isAdmin) =>{
    let url = ApiUrlAdmin + `credit/addbulksalecreditv2`
    return await post(url,data,token,isAdmin)
}
export const assignProduct = async (data,token,isAdmin) =>{
    let url = ApiUrlAdmin + `credit/addcreditfromadminpanelv2`
    return await post(url,data,token,isAdmin)
}
export const getpanelproducts = async (token,isAdmin) =>{
    let url = ApiUrlAdmin + `productstore/getpanelproducts`
    return await getAdmin(url,token,isAdmin)
}
export const getUserInfo = async(data, token,isAdmin) => {
    let url = ApiUrlAdmin + 'account/getuserinfo'
    return await post(url,data,token,isAdmin);
};